__turbopack_context__.v({
  "checkmark": "style-module-scss-module__Z-VmfG__checkmark",
  "modal-component": "style-module-scss-module__Z-VmfG__modal-component",
  "right": "style-module-scss-module__Z-VmfG__right",
  "success": "style-module-scss-module__Z-VmfG__success",
});
